import React from 'react';
import '../styles/Blacklist.css'
import NumberContainer from '../components/NumberCmp';
import axios from 'axios'

class Blacklist extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            numbers: [],
            searchTerm: ''
        };
    }

    componentDidMount() {
        axios.get("http://safetel.ddns.net:5000/user_num_status?user_id=PROTOTYPE_USER_1")
        .then((response) => {
            this.setState({
                isLoaded: true,
                numbers: response.data.numbers
            })
        })
        .catch((error) => {
            this.setState({
                isLoaded: true,
                error
            })
        })
    }

    editSearchTerm = (e) => {
        this.setState({ searchTerm: e.target.value })
    }

    setLastCall = () => {
        return this.state.numbers.forEach(elem => {
            let theElemCall = elem.time[elem.time.length - 1]
            if (theElemCall !== undefined) {
                let date = new Date(theElemCall) //convert to js time later (no miliseconds in unix time)
                let hours = date.getHours();
                let minutes = "0" + date.getMinutes();
                let seconds = "0" + date.getSeconds();
                let formattedTime = date.toLocaleDateString("en-UK") + " " + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
                elem.lastcall = formattedTime
            }
            else {
                elem.lastcall = "No current call"
            }
        })
    }

    dynamicSearch = () => {
        return this.state.numbers.filter(numbers => {
            return numbers.number.includes(this.state.searchTerm)
        }).filter(numbers => {
            return (numbers.blocked === true)
        }).sort((a, b) => {
            return a.time[a.time.length - 1] - b.time[b.time.length - 1]
        })
    }

    render() {
        const { error, isLoaded } = this.state;
        if (error) {
            return (<div>Erreur : {error.message}</div>);
        } else if (!isLoaded) {
            return (<div>Chargement...</div>);
        } else {
            return (
                <div>
                    <h1 className="title">Liste noire</h1>
                    <div style={{ textAlign: 'center', paddingTop: '30vh' }}>
                        <input type='text' value={this.state.searchTerm} onChange={this.editSearchTerm} placeholder='chercher un numéro!' />
                        <br></br>
                        <br></br>
                        <NumberContainer numbers={this.dynamicSearch(this.setLastCall())} />
                    </div>
                </div>
            );
        }
    }
}

export default Blacklist;